import { useState } from 'react';
import { Download, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { exportToCsv, type CsvColumn } from '../../lib/csv';
import { getErrorMessage } from '@/lib/errors';

interface ExportCsvButtonProps<T> {
  /**
   * Загружает все строки для выгрузки с учётом текущих фильтров
   * (постраничную догрузку делает сама функция).
   */
  fetchRows: () => Promise<T[]>;
  columns: CsvColumn<T>[];
  filename: string;
  disabled?: boolean;
}

/** «Экспорт CSV» — вторичная кнопка из макета «Пользователи». Цвета — из токенов темы. */
export function ExportCsvButton<T>({ fetchRows, columns, filename, disabled }: ExportCsvButtonProps<T>) {
  const [busy, setBusy] = useState(false);

  const handle = async () => {
    setBusy(true);
    try {
      const rows = await fetchRows();
      if (rows.length === 0) {
        toast.info('Нет данных для выгрузки');
        return;
      }
      const ts = new Date().toISOString().replace(/[:.]/g, '-').slice(0, 19);
      exportToCsv(rows, columns, `${filename}_${ts}.csv`);
      toast.success(`Выгружено строк: ${rows.length}`);
    } catch (e: unknown) {
      toast.error(getErrorMessage(e, 'Не удалось выгрузить CSV'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button type="button" variant="secondary" onClick={handle} disabled={busy || disabled} aria-busy={busy || undefined}>
      {busy ? <Loader2 className="animate-spin" /> : <Download />}
      Экспорт CSV
    </Button>
  );
}
